import React, { useCallback, useEffect, useState } from "react";
import LocContext from "./locContext";
import {
  readStoredUser,
  refreshMutualStatusFromServer,
} from "../../utils/clientInvestorProfile";

const LocState = (props) => {
  const [userData, setUserData] = useState(() => readStoredUser() || "");

  const refreshUserData = useCallback(async () => {
    try {
      const next = await refreshMutualStatusFromServer();
      if (next) {
        setUserData(next);
        return next;
      }
    } catch (err) {
      console.error("refreshUserData:", err);
    }
    const stored = readStoredUser();
    if (stored) setUserData(stored);
    return stored || null;
  }, []);

  useEffect(() => {
    const onSessionUpdate = () => {
      const stored = readStoredUser();
      if (stored) setUserData(stored);
    };
    window.addEventListener("investorOnboardingUpdated", onSessionUpdate);
    return () => {
      window.removeEventListener("investorOnboardingUpdated", onSessionUpdate);
    };
  }, []);

  return (
    <LocContext.Provider value={{ userData, setUserData, refreshUserData }}>
      {props.children}
    </LocContext.Provider>
  );
};

export default LocState;
